import Vue from 'vue';
import App from './App.vue';
import 'es6-promise/auto';
import axios from 'axios';
import VueAuth from '@websanova/vue-auth';
import VueAxios from 'vue-axios';
import VueRouter from 'vue-router';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';

// Vuesax Component Framework
import Vuesax from 'vuesax';
import 'material-icons/iconfont/material-icons.css';
import 'vuesax/dist/vuesax.css';
Vue.use(VueLodash, { lodash: lodash });
Vue.use(Vuesax);

// Globally Components
import 'config/global-components';

// Styles: SCSS
import 'assets/scss/main.scss';

// Tailwind
import 'assets/css/main.css';

// Vuex Store
import store from './store/store';

// PrismJS
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';

// Feather font icon
require('./assets/css/iconfont.css');

/** Plugins*/
import $axios from './plugins/axios';
Vue.use($axios);

import Clipboard from 'v-clipboard';
Vue.use(Clipboard);

import VueClipboard from 'vue-clipboard2';
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard)

import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, {});

Vue.config.productionTip = false;

/** Router */
import router from './router';
Vue.router = router;
Vue.use(VueRouter);

/** Axios **/
Vue.use(VueAxios, axios);
axios.defaults.baseURL = `${process.env.VUE_APP_API_URL}/api`;

Vue.use(require('vue-moment'));

/** Auth **/
import auth from './config/auth';
Vue.use(VueAuth, auth);

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
Vue.component(VueCropper);

import 'beautify-scrollbar/dist/index.css';
import 'v2-table/dist/index.css';
import V2Table from 'v2-table';

Vue.use(V2Table);

import './filters/format-number';

new Vue({
    store,
    router,
    render: (h) => h(App)
}).$mount('#app');
